import React, { FC } from 'react';

import Select from '@ui/Select';
import FormFieldWrapper from '../Wrapper';
import { ISelectFormFieldProps } from './interfaces';

const SelectFormField: FC<ISelectFormFieldProps> = ({
  name,
  label,
  children,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      label={label}
      render={fieldProps => (
        <Select {...props} {...fieldProps}>
          {children}
        </Select>
      )}
    />
  );
};

export default SelectFormField;
